<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Digital Print Makeup
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Overview</a>
          <ul>
            <li @click="activeMenuLink = 'makeup/overview'"><router-link to="/makeup/overview"  :class="{'is-active':activeMenuLink === 'makeup/overview'}">Overview</router-link></li>
            <li @click="activeMenuLink = 'makeup/work-in-progress'"><router-link to="/makeup/work-in-progress"  :class="{'is-active':activeMenuLink === 'makeup/work-in-progress'}">Work In Progress</router-link></li>
            <li @click="activeMenuLink = 'makeup/to-be-completed'"><router-link to="/makeup/to-be-completed"  :class="{'is-active':activeMenuLink === 'makeup/to-be-completed'}">To Be Completed</router-link></li>
            <li @click="activeMenuLink = 'makeup/view-order'"><router-link to="/makeup/view-order"  :class="{'is-active':activeMenuLink === 'makeup/view-order'}">Find an Order</router-link></li>
          </ul>
        </li>
        <li>
          <a class="">Reports</a>
          <ul>
            <li @click="activeMenuLink = 'reports/bundle-summary'"><router-link to="/reports/bundle-summary"  :class="{'is-active':activeMenuLink === 'reports/bundle-summary'}">Summary Report</router-link></li>
             
          </ul>
        </li>

        <li>
          <a class="">Data Input</a>
          <ul>
            <li @click="activeMenuLink = 'makeup/data-input'"><router-link to="/makeup/data-input"  :class="{'is-active':activeMenuLink === 'makeup/data-input'}">Makeup Factory Floor</router-link></li>
            
          </ul>
        </li>
        <li v-if="task_allowed('productivity_scanning')">
          <a class="">Productivity</a>
          <ul>
            <li @click="activeMenuLink = 'makeup/productivity-scanning'" >
              <router-link to="/makeup/productivity-scanning"  :class="{'is-active':activeMenuLink === 'makeup/productivity-scanning'}">Productivity Scanning</router-link>
            </li>
            <li @click="activeMenuLink = 'makeup/productivity-reporting'" >
              <router-link to="/makeup/productivity-reporting"  :class="{'is-active':activeMenuLink === 'makeup/productivity-reporting'}">Productivity Reporting</router-link>
            </li>
          </ul>
        </li>
        <li>
          <a class="">Off Shore Data Input</a>
          <ul>
            <li @click="activeMenuLink = 'makeup/data-input-offshore'"><router-link to="/makeup/data-input-offshore"  :class="{'is-active':activeMenuLink === 'makeup/data-input-offshore'}">Makeup (Off Shore Only)</router-link></li>
            
          </ul>
        </li>
        
        
      </ul>

      
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarMakeup',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



